import { Box, Stack, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { FoodsIcon, Button, Typography } from "@foodpilot/foods";
import { usePortalSession } from "src/api/client-api/payment/usePortalSession";
import { useApplicationParameters } from "src/api/client-api/appParams/useApplicationParameters";
import { useFoodpilotContext, MODIFY_ORG_SETTINGS, ORGANIZATION } from "src/context/FoodpilotContext";

export const PaymentBillingTab = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isFeatureActivated } = useApplicationParameters();
    const isPaymentEnabled = isFeatureActivated("FS-payment-enabled");

    const {
        openPortal,
        loading: portalLoading,
        error: portalError,
    } = usePortalSession({
        returnUrl: window.location.href,
        isPaymentFeatureEnabled: isPaymentEnabled,
    });
    const { canUser } = useFoodpilotContext();
    const canModify = canUser(MODIFY_ORG_SETTINGS, ORGANIZATION);

    return (
        <Stack gap={theme.spacing(4)}>
            {!isPaymentEnabled && (
                <Alert severity="info">
                    {t(
                        "companySettings.payment.feature_disabled",
                        "Payment feature is not enabled. Contact your administrator.",
                    )}
                </Alert>
            )}
            {portalError && <Alert severity="error">{portalError}</Alert>}
            <Box
                sx={{
                    backgroundColor: "white",
                    border: "1px solid #E0DEDD",
                    borderRadius: theme.spacing(2),
                }}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{
                        px: theme.spacing(4),
                        py: theme.spacing(3),
                    }}
                >
                    <Typography variant="h3" sx={{ fontSize: "20px", fontWeight: 700 }}>
                        {t("companySettings.payment.title", "Payment method & history")}
                    </Typography>
                    {canModify && (
                        <Button
                            variant="primary"
                            onClick={openPortal}
                            endIcon={<FoodsIcon icon="openNewTab" size={1.5} />}
                            disabled={portalLoading || !isPaymentEnabled}
                            sx={{
                                textTransform: "none",
                                fontWeight: 700,
                            }}
                        >
                            {t("companySettings.payment.manage", "Manage payment method & history")}
                        </Button>
                    )}
                </Stack>
            </Box>
        </Stack>
    );
};
